module.exports = __webpack_public_path__ + "img/cancelCircle.cdb8baf4.svg";